import { Component } from '@angular/core';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';
import {
  DAIRYNEXT_WORKSPACE_ID,
  DAIRYNEXT_REPORT_IDS,
  SINGLE_PAGE_POWERBI_CONFIG,
} from 'src/app/shared/models/powerbi-config.model';

@Component({
  selector: 'app-dairy-overview',
  templateUrl: './dairy-overview.component.html',
  imports: [PowerbiReportComponent],
})
export class DairyOverviewComponent {
  public readonly workspaceId = DAIRYNEXT_WORKSPACE_ID;
  public readonly reportId = DAIRYNEXT_REPORT_IDS.DAIRY_OVERVIEW;
  public readonly baseEmbedConfig = SINGLE_PAGE_POWERBI_CONFIG;
}
